<template>
  <div class="sentiment-trends" v-loading="isLoading"> 
    <sentiment-trend-chart @checkedDate="checkedDate" :search-text="searchText" @done="chartDone" v-if="isRerender"></sentiment-trend-chart>
  </div>
</template>

<script>
import SentimentTrendChart from '@/components/common/SentimentTrendChart';

export default {
  props: {
    searchText: {
      type: String
    }
  },
  data() {
    return {
      isLoading: true,
      isRerender: true
    };
  },
  methods: {
    chartDone() {
      this.isLoading = false;
    },
    checkedDate(date) {
      this.$emit('checkedDate', date);
    }
  },
  watch: {
    searchText() {
      this.isLoading = true;
      this.isRerender = false;
      this.$nextTick(() => this.isRerender = true);
    }
  },
  components: {
    SentimentTrendChart
  }
};
</script>
<style lang="scss" scoped>
.sentiment-trends {
  position: relative;
  width: 100%;
  height: 340px;
  background-color: #333138;

  /deep/ .el-loading-mask {    
    margin: 0 20px;
    background: #ffffff !important; 
    min-height: 280px;
    border-radius: 10px;   
  }
}
</style>

